module.exports = __webpack_public_path__ + "static/media/extra-time.4d418333.svg";